var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-table',{ref:"table",attrs:{"columns":_vm.columns,"actions":_vm.tableActions,"url":"private-kb","params":{groups: ['domains']}},scopedSlots:_vm._u([{key:"item.url",fn:function({ item }){return [_c('router-link',{attrs:{"to":{name: 'articles.show', params: {id: item.slug}}}},[_vm._v(_vm._s(item.url))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }